import { isUndefined as w } from "lodash";
const f = (o, r, d) => {
  var n, e;
  let a = "";
  const v = r.filter((i) => i.validation !== void 0 && i.validation.indicator === "Row");
  for (const i of v) {
    const t = i.field, l = (n = i.validation) == null ? void 0 : n.validator;
    t && l && !w((e = o.data) == null ? void 0 : e[t]) && !l({ data: o.data[t], rowData: o.data }) ? (d.addInvalidRow(o.rowIndex), a += " row-invalid-data ") : d.removeInvalidRow(o.rowIndex);
  }
  return a;
};
export {
  f as getRowClass
};
//# sourceMappingURL=index.es603.js.map
